import { Observable } from 'rxjs';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';
import { map, takeUntil } from 'rxjs/operators';

export namespace SpecialScenariosField {
  export class Visible extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      return experiencesService.commandDcoEnabled$().pipe(
        takeUntil(this.ngDestroy),
        map((availables) => availables),
      );
    }
  }

  export class Hidden extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      return experiencesService.commandDcoEnabled$().pipe(
        takeUntil(this.ngDestroy),
        map((availables) => !availables),
      );
    }
  }
}
